module.exports = __webpack_public_path__ + "img/2024-09-19c_3.99f4b833.jpg";